import { Routes } from '@angular/router';
import { RoleEnum } from '@core/config/role.enum';
import { authGuardWithRedirectFn } from 'ok-angular-shared/auth';
import { InstallationInfoRouteResolverService } from './installation-info/services/installation-info-route-resolver.service';
import { installationRoutes } from './installation/installation.routes';
import { PageMinimumComponent } from './pages/page-minimum/page-minimum.component';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { EmailUnsubscribeRouteResolverService } from './unsubscribe/email-unsubscribe-overview/services/email-unsubscribe-route-resolver.service';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/page-full/page-full.component').then(m => m.PageFullComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
        canActivate: [authGuardWithRedirectFn],
        data: {
          roles: [
            RoleEnum.CarDealer,
            RoleEnum.Subcontractor,
            RoleEnum.Pkc,
            RoleEnum.Tsc,
            RoleEnum.Emobility,
            RoleEnum.Credit,
            RoleEnum.Screening,
            RoleEnum.Ekc,
          ],
        },
        title: 'OK - Ladepakke abonnementsportal',
      },
      {
        path: 'create-pkc-subscription',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/pkc-create-subscription-saftl/pkc-subscription-form-saftl/pkc-subscription-form-saftl.component').then(
            m => m.PkcSubscriptionFormSaftlComponent
          ),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Opret Privat Abonnement',
      },
      {
        path: 'create-pkc-offer',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/create-subscription-offer/create-subscription-offer.component').then(
            m => m.CreateSubscriptionOfferComponent
          ),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility] },
        title: 'Opret tilbud',
      },
      {
        path: 'create-pkc-offer/receipt',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/create-subscription-offer/create-subscription-offer-receipt/create-subscription-offer-receipt.component').then(
            m => m.CreateSubscriptionOfferReceiptComponent
          ),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility] },
        title: 'Opret tilbud',
      },
      {
        path: 'create-pkc-subscription?CustomerNumber=:customerNumber',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/pkc-create-subscription-saftl/pkc-subscription-form-saftl/pkc-subscription-form-saftl.component').then(
            m => m.PkcSubscriptionFormSaftlComponent
          ),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Opret Privat Abonnement',
      },
      {
        path: 'create-pkc-subscription/receipt',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/pkc-create-subscription-saftl/pkc-subscription-receipt-saftl/pkc-subscription-receipt-saftl.component').then(
            m => m.PkcSubscriptionReceiptSaftlComponent
          ),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Opret Privat Abonnement',
      },
      {
        path: 'create-hlf-subscription',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/hlf-create-subscription-saftl/hlf-create-subscription-saftl.component').then(
            m => m.HlfCreateSubscriptionSaftlComponent
          ),
        data: { roles: [RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Opret HLF Abonnement',
      },
      {
        path: 'create-hlf-subscription/receipt',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/hlf-create-subscription-saftl/hlf-subscription-receipt-saftl/hlf-subscription-receipt-saftl.component').then(
            m => m.HlfSubscriptionReceiptSaftlComponent
          ),
        data: { roles: [RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Opret HLF Abonnement',
      },
      {
        path: 'change-customer-order/:subscriptionId',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./subscription/change-customer-order/change-customer-order.component').then(m => m.ChangeCustomerOrderComponent),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Emobility, RoleEnum.Ekc] },
        title: 'Rediger Bestilling',
      },
      {
        path: 'customer/:id',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () => import('./client-information/client-page/client-page.component').then(m => m.ClientPageComponent),
        data: { roles: [RoleEnum.Pkc, RoleEnum.Tsc, RoleEnum.Emobility, RoleEnum.Credit, RoleEnum.Screening, RoleEnum.Ekc] },
        title: 'Kundeinformation',
      },
      {
        path: 'product',
        canActivate: [authGuardWithRedirectFn],
        data: { roles: [RoleEnum.Emobility] },
        loadComponent: () => import('./product/product-overview/product-overview.component').then(m => m.ProductOverviewComponent),
        title: 'Administrer Produkter',
      },
      {
        path: 'organizations',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./organization/organization-overview/organization-overview.component').then(m => m.OrganizationOverviewComponent),
        data: { roles: [RoleEnum.Emobility] },
        title: 'Administrer Organisationer',
      },
      {
        path: 'hardware-product',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./hardware-product/hardware-product-overview/hardware-product-overview.component').then(
            m => m.HardwareProductOverviewComponent
          ),
        data: { roles: [RoleEnum.Emobility] },
        title: 'Administrer Hardwareprodukter',
      },
      {
        path: 'screenings',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () => import('./screening/screening-overview/screening-overview.component').then(m => m.ScreeningOverviewComponent),
        data: { roles: [RoleEnum.Emobility, RoleEnum.Screening] },
        title: 'Screeninger',
      },
      {
        path: 'subcomponent',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./hardware-product/subcomponent-overview/subcomponent-overview.component').then(m => m.SubcomponentOverviewComponent),
        data: { roles: [RoleEnum.Emobility] },
      },
      {
        path: 'bilinfo/car-dealer',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () => import('./bilinfo/car-dealer-overview/car-dealer-overview.component').then(m => m.CarDealerOverviewComponent),
        data: { roles: [RoleEnum.Emobility] },
      },
      ...installationRoutes,
    ],
  },
  {
    path: '',
    component: PageMinimumComponent,
    data: { disableOkLink: true },
    children: [
      {
        path: 'installation-info/:identifier',
        loadComponent: () =>
          import('./installation-info/installation-info-overview/installation-info-overview.component').then(
            m => m.InstallationInfoOverviewComponent
          ),
        resolve: {
          installationInfoResponse: InstallationInfoRouteResolverService,
        },
      },
      {
        path: 'fill-installation-info/:identifier', // Used to fill the screening form for a customer, but include the token from auth service since the route is not public
        loadComponent: () =>
          import('./installation-info/installation-info-overview/installation-info-overview.component').then(
            m => m.InstallationInfoOverviewComponent
          ),
        resolve: {
          installationInfoResponse: InstallationInfoRouteResolverService,
        },
      },
      {
        path: 'installation-info-edit/:id',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () =>
          import('./installation-info/installation-info-overview/installation-info-overview.component').then(
            m => m.InstallationInfoOverviewComponent
          ),
        data: { roles: [RoleEnum.Emobility, RoleEnum.Screening] },
        resolve: {
          installationInfoResponse: InstallationInfoRouteResolverService,
        },
      },
      {
        path: 'unsubscribe/:customerId/:emailTypeId',
        loadComponent: () =>
          import('./unsubscribe/email-unsubscribe-overview/email-unsubscribe-overview.component').then(
            m => m.EmailUnsubscribeOverviewComponent
          ),
        resolve: {
          resolverResponse: EmailUnsubscribeRouteResolverService,
        },
      },
    ],
  },
  {
    path: 'feature-explorer',
    component: PageMinimumComponent,
    children: [
      {
        path: '',
        canActivate: [authGuardWithRedirectFn],
        loadComponent: () => import('./feature-explorer/feature-explorer.component').then(m => m.FeatureExplorerComponent),
        data: { roles: [RoleEnum.Developer, RoleEnum.Emobility] },
        title: 'Funktionsoversigt',
      },
    ],
  },
  {
    path: 'not-found',
    component: PageMinimumComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: PageNotFoundComponent,
        title: 'Siden blev ikke fundet',
      },
    ],
  },
  {
    path: 'unauthorized',
    title: 'Ingen adgang',
    loadComponent: () => import('./pages/no-access/no-access.component').then(m => m.NoAccessComponent),
  },
  {
    path: '**', // Must be last!
    redirectTo: '/not-found',
  },
];
